export const baseApi = (enviroment) => {
  const baseUrl = [
    { env: 'prod', url: 'https://api.reworth.app/v1/directory/v2' },
    { env: 'latest', url: 'https://api.reworth.app/latest/directory/v2' },
    { env: 'dev', url: 'https://api.reworth.app/dev/directory/v2' },
    { env: 'local', url: 'http://localhost:3000/directory/v2' },
    { env: 'legacy', url: 'https://api.reworth.app/v1/directory/v2' },
    { env: 'qa', url: 'https://api.reworth.app/qa/directory/v2' }
  ]

  let base = ''
  baseUrl.forEach((item, i) => {
    if (item.env === enviroment) {
      base = item.url
    }
  })
  return base
}
